// 防伪码
export default [

  {
    path: '/openMiniApp',
    component: () => import('@/pages/openMiniApp/openMiniApp.vue'),
    meta: {
      title: '打开小程序',
    },
  },

];
